module.exports = __webpack_public_path__ + "static/media/emergencia.fd60bf1a.svg";